<template>
	<li>
		<router-link :to="{ name: 'EquipmentDetail', params: { id: getEqName(node.parent_id) }}" v-if="node.parent_id != ''">
			<img width="55" v-lazy="'/static/images/equipment/icon_equipment_'+ node.parent_id +'.png'">
			{{getEqName(node.parent_id) }}
		</router-link>
		<ul v-if="node.children && node.children.length">
			<node v-for="child in node.children" :node="child" :key="node.parent_id" v-once></node>
		</ul>
	</li>
</template>
<script>
export default {
	name: "node",
	props: {
		node: Object
	},
	methods: {
		getI18nName: function(item, name) {
			switch (this.$i18n.locale) {
				case "en":
					return item["en_" + name];
					break;
				case "jp":
					return item["jp_" + name];
					break;
				default:
					return item[name];
					break;
			}
		},
		getEqName: function(eq_id) {
			var self = this;
			var eq = _.find(self.$store.getters.getEquipmentCraft, function(o) {
				return o.condition_equipment_id_1 == eq_id;
			});
			if (eq) {
				var eqData = _.find(self.$store.getters.getEquipmentData, function(o) {
					return o.equipment_id == eq.equipment_id;
				});
				return this.getI18nName(eqData, 'equipment_name');
			} else {
				var eqData = _.find(self.$store.getters.getEquipmentData, function(o) {
					return o.equipment_id == eq_id;
				});
				return this.getI18nName(eqData, 'equipment_name');
			}
		},
	},
	mounted: function() {
		// var language = localStorage.getItem("language");
		// if (language) {			
        //     this.$i18n.locale = language;
        //     this.locale = language;
        // }
	}
};
</script>